import { render, staticRenderFns } from "./questionOptions.vue?vue&type=template&id=19637606&scoped=true&"
import script from "./questionOptions.vue?vue&type=script&lang=js&"
export * from "./questionOptions.vue?vue&type=script&lang=js&"
import style0 from "./questionOptions.vue?vue&type=style&index=0&id=19637606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19637606",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VDialog,VImg})
